import { createSlice } from "@reduxjs/toolkit";

export const alertNoticeSettingSlice = createSlice({
  name: "alertNoticeSetting",
  initialState: {
    getAlertNoticeSettingResult: false,
    getAlertNoticeSettingLoading: false,
    getAlertNoticeSettingError: false,
    addAlertNoticeSettingResult: false,
    addAlertNoticeSettingLoading: false,
  },
  reducers: {
    alertNoticeSettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_ALERTNOTICESETTING":
          return {
            ...state,
            getAlertNoticeSettingResult: payload.data,
            getAlertNoticeSettingLoading: payload.loading,
            getAlertNoticeSettingError: payload.error,
          };
        case "ADD_ALERTNOTICESETTING":
          return {
            ...state,
            addAlertNoticeSettingResult: payload.data,
            addAlertNoticeSettingLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { alertNoticeSettingReducers } = alertNoticeSettingSlice.actions;

export default alertNoticeSettingSlice.reducer;
